import config from 'config';
import { connect } from 'react-redux';
import { flow, property } from 'lodash';
import { routeMap } from 'router';
import Storage from 'services/Storage';
import { showModal } from '../../App/redux/accessibility/actions';

import AuthorizationPage from '../components/AuthorizationPage';
import { startRequest as captchaRequest } from '../redux/captcha/actions';
import { startRequest as checkTokenRequest } from '../redux/check/actions';
import {
  ESAuthRequestStart as ESAuthRequest,
  ESAuthWithEmail,
  startRequest as loginRequest,
  startWorking,
} from '../redux/login/actions';
import { checkInnAndPassword } from '../services/API';
import getTemporaryBannerStatus from '../services/API/temporaryBannerEnabled';
import errorMessages from '../../../constants/errorMessages';
import { createStructuredSelector } from 'reselect';
import { selectRouter } from 'modules/App/utils/selectors';
import withQueryClient from 'hocs/withQueryClient';

const innAndPwdStatuses = {
  1: 'Указанный Вами ИНН отсутствует в Личном кабинете. Возможно, Вы ввели некорректные данные или Ваш личный кабинет еще формируется (может занять несколько дней).',
  2: 'Ваш личный кабинет формируется (может занять несколько дней). Пожалуйста, попробуйте зайти позже.',
};

class AuthorizationPageContainer extends AuthorizationPage {
  componentDidMount() {
    const { checkTokenRequest, queryClient } = this.props;

    getTemporaryBannerStatus().then((result) => {
      if (result.isOk && result.data.isEnabled) {
        this.setState({
          showTemporaryBanner: true,
          temporaryBannerContent: result.data.text,
        });
      }
    });
    // get token
    const token = Storage.getItem(config.tokenItemName);

    if (!token) {
      queryClient.clear();
      return;
    }

    // check token
    checkTokenRequest(token);
  }

  getCaptcha(inn) {
    const { captchaRequest } = this.props;
    captchaRequest(inn);
  }

  authorize() {
    const { loginRequest, queryClient } = this.props;
    const username = this.usernameInput.value;
    const password = this.passwordInput.value;
    const data = new FormData();

    data.append('username', username);
    data.append('password', password);

    if (this.state.showCaptcha) {
      data.append('captcha', this.state.captchaValue);
    }
    this.setState({ checkingLoading: true });
    checkInnAndPassword(username)
      .then((res) => {
        if (!res.isOk) {
          throw res.error;
        }
        if (!res.data) {
          loginRequest({
            data: data,
            redirectUrl: routeMap.home,
            username,
            rememberMe: this.state.rememberMe,
          });
        } else {
          this.setState({ submitError: innAndPwdStatuses[res.data] });
        }

        this.setState({ checkingLoading: false });
      })
      .catch(() => {
        this.setState({
          checkingLoading: false,
          submitError: errorMessages.serverErrorWithOutLinks,
        });
      })
      .finally(() => {
        queryClient.clear();
      });
  }

  ESAuthorize({ sign, certHash }, email = '') {
    const { ESAuthWithEmail, ESAuthRequest } = this.props;
    const data = new FormData();
    data.append('username', email);
    data.append('password', certHash);
    data.append('sign', sign);

    const action = email ? ESAuthWithEmail : ESAuthRequest;

    action({
      data,
      redirectUrl: routeMap.home,
    });
  }

  showAccessibilityModal() {
    const { showModal } = this.props;
    showModal();
  }

  startWorking() {
    const { startWorking } = this.props;
    startWorking();
  }
}

const mapStateToProps = createStructuredSelector({
  router: selectRouter,
  authorization: property('authorization.login'),
  check: property('authorization.check'),
  captcha: property('authorization.captcha'),
  resetPasswordData: flow(property('app.incomingData'), (incomingData) => incomingData.get('data')),
});

const mapDispatchToProps = {
  checkTokenRequest,
  captchaRequest,
  ESAuthWithEmail,
  ESAuthRequest,
  showModal,
  startWorking,
  loginRequest,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withQueryClient(AuthorizationPageContainer));
